
<ng-container>
   <div [innerHTML]="banner"></div>
</ng-container>